const scheduleIdleWork = (fn: TimerHandler & IdleRequestCallback, timeout: number = 0) => {
  const handler = window.requestIdleCallback(fn, { timeout });

  return () => window.cancelIdleCallback(handler);
};

export default scheduleIdleWork;
